import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { authAPI, fmtError } from '@/lib/api';
import Logo from '@/components/Logo';

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const [password, setPassword] = useState('');
  const [err, setErr] = useState('');
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setErr('');
    try {
      await authAPI.reset({ token, password });
      nav('/login');
    } catch (e2) { setErr(fmtError(e2)); }
  };

  return (
    <div className="min-h-screen bg-black">
      <div className="max-w-md mx-auto px-6 py-14">
        <Link to="/" className="inline-block mb-10"><Logo size={28} /></Link>
        <div className="card-tech rounded-lg p-8">
          <h1 className="font-display text-3xl">Set a new password</h1>
          <form onSubmit={submit} className="mt-6 space-y-3" data-testid="reset-form">
            <input type="password" required minLength={6} className="input-tech" value={password} onChange={e => setPassword(e.target.value)} placeholder="New password" data-testid="reset-password" />
            {err && <div className="text-sm text-[#ff3366]" data-testid="reset-error">{err}</div>}
            <button className="btn-primary w-full justify-center" data-testid="reset-submit">Update password</button>
          </form>
        </div>
      </div>
    </div>
  );
}
